export default __webpack_public_path__ + "static/store-badge-amazon.7b5a03e8.svg";